/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingPlanDefinitionFilters {
    getFixupPrototypeFunction() { return BillingPlanDefinitionFilters.fixupPrototype; }

    static newInstance(model: Partial<BillingPlanDefinitionFilters>): BillingPlanDefinitionFilters {
        let obj = Object.assign(new BillingPlanDefinitionFilters(), model);
        BillingPlanDefinitionFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingPlanDefinitionFilters>): BillingPlanDefinitionFilters {
        if (!model) return null;
        return BillingPlanDefinitionFilters.newInstance(<BillingPlanDefinitionFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingPlanDefinitionFilters) {
        if (!obj) return;

        models.BillingPlanDefinitionFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingPlanDefinitionFilters): boolean {
        Object.setPrototypeOf(obj, BillingPlanDefinitionFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.from_date === "string") {
            this.from_date = new Date(<string><any>this.from_date);
        }
        if (typeof this.to_date === "string") {
            this.to_date = new Date(<string><any>this.to_date);
        }
        if (this.scope) {
            models.QueryOperator.fixupPrototype(this.scope);
        }
    }

    /**
     * Search by name or description
     */
    search: string;

    /**
     * Plan Status. This field is used to indicate the status of the billing plan.
     */
    plan_status: models.PlanStatus;

    /**
     * Scope is/is not/contains/not contains the given value
     */
    scope: models.QueryOperator;

    /**
     * Billing Plan ends after this date
     */
    from_date: Date;

    /**
     * Billing Plan starts before this date
     */
    to_date: Date;

    /**
     * raw_list_cost_adjusted_billing_plan
     */
    raw_list_cost_adjusted_billing_plan: boolean = false;

}
